import React, { useContext, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import moment from 'moment';

import { injectIntl } from 'react-intl';
import { Field, Form, Formik } from 'formik';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { FormServiceContext } from 'app/utils/contexts';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormLabel,
    FormHelperText,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import notification from 'app/config/notification';
import { verifyLicencaNameAndFormat } from 'app/utils/forms/services/licenses';

const SchedulesDialog = (props) => {
    const { open, handleCancel, handleSave, selectedSchedule } = props;

    const [hrInicial, setHrInicial] = useState(null);
    const [hrFinal, setHrFinal] = useState(null);

    const handleChange = (field, date, setFieldValue) => {
        if (field === 'hrInicial') {
            setHrInicial(moment(date));
        } else {
            setHrFinal(moment(date));
        }
        setFieldValue(field, moment(date));
    };

    const saveContent = (values, selectedSchedule) => {
        const response = handleSave(values, selectedSchedule);
        if (response) {
            setHrInicial(null);
            setHrFinal(null);
        }
    };

    const validationSchema = Yup.object()
        .shape({
            hrInicial: Yup.date().required('Campo obrigatório').typeError('Informação inválida').nullable(),
            hrFinal: Yup.date().required('Campo obrigatório').typeError('Informação inválida').nullable(),
            boSegunda: Yup.boolean(),
            boTerca: Yup.boolean(),
            boQuarta: Yup.boolean(),
            boQuinta: Yup.boolean(),
            boSexta: Yup.boolean(),
            boSabado: Yup.boolean(),
            boDomingo: Yup.boolean(),
        })
        .test(
            'checkBoxValidation',
            null,
            ({ boSegunda, boTerca, boQuarta, boQuinta, boSexta, boSabado, boDomingo }) => {
                if (boSegunda || boTerca || boQuarta || boQuinta || boSexta || boSabado || boDomingo) {
                    return true;
                }

                return new Yup.ValidationError('Selecione um dos campos', null, 'checkBoxValidation');
            },
        );

    const onCancel = (e, reason) => {
        if (reason && reason === 'backdropClick') return;
        if (handleCancel) handleCancel(e);
    };

    return (
        <Dialog disableEscapeKeyDown open={open} onClose={onCancel}>
            <DialogTitle>Informe os horários</DialogTitle>
            <Formik
                enableReinitialize={true}
                initialValues={{
                    hrInicial: '',
                    hrFinal: '',
                    boSegunda: false,
                    boTerca: false,
                    boQuarta: false,
                    boQuinta: false,
                    boSexta: false,
                    boSabado: false,
                    boDomingo: false,
                }}
                validationSchema={validationSchema}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={() => {}}>
                {(formProps) => {
                    return (
                        <Form>
                            <DialogContent style={{ paddingTop: '0px', maxWidth: '350px' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Field
                                            name="hrInicial"
                                            label="Horário Inicial*"
                                            format="HH:mm"
                                            autoOk
                                            clearable
                                            clearLabel={'Limpar'}
                                            emptyLabel={''}
                                            invalidLabel="Informação inválida"
                                            invalidDateMessage="Informação inválida"
                                            maxDateMessage="Informação inválida"
                                            minDateMessage="Informação inválida"
                                            margin="dense"
                                            ampm={false}
                                            value={hrInicial}
                                            onChange={(e) => handleChange('hrInicial', e, formProps.setFieldValue)}
                                            inputVariant="filled"
                                            fullWidth
                                            error={!!formProps.errors.hrInicial}
                                            helperText={formProps.errors.hrInicial ? formProps.errors.hrInicial : ''}
                                            as={KeyboardTimePicker}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            name="hrFinal"
                                            label="Horário Final*"
                                            format="HH:mm"
                                            autoOk
                                            clearable
                                            clearLabel={'Limpar'}
                                            emptyLabel={''}
                                            invalidLabel="Informação inválida"
                                            invalidDateMessage="Informação inválida"
                                            maxDateMessage="Informação inválida"
                                            minDateMessage="Informação inválida"
                                            margin="dense"
                                            ampm={false}
                                            value={hrFinal}
                                            onChange={(e) => handleChange('hrFinal', e, formProps.setFieldValue)}
                                            inputVariant="filled"
                                            fullWidth
                                            error={!!formProps.errors.hrFinal}
                                            helperText={formProps.errors.hrFinal ? formProps.errors.hrFinal : ''}
                                            as={KeyboardTimePicker}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <FormLabel component="legend">Dias da semana*</FormLabel>
                                            <Grid item xs={12}>
                                                <label>
                                                    <Field as={Checkbox} color="primary" name="boSegunda" /> Segunda
                                                </label>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <label>
                                                    <Field as={Checkbox} color="primary" name="boTerca" /> Terça
                                                </label>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <label>
                                                    <Field as={Checkbox} color="primary" name="boQuarta" /> Quarta
                                                </label>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <label>
                                                    <Field as={Checkbox} color="primary" name="boQuinta" /> Quinta
                                                </label>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <label>
                                                    <Field as={Checkbox} color="primary" name="boSexta" /> Sexta
                                                </label>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <label>
                                                    <Field as={Checkbox} color="primary" name="boSabado" /> Sábado
                                                </label>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <label>
                                                    <Field as={Checkbox} color="primary" name="boDomingo" /> Domingo
                                                </label>
                                            </Grid>
                                            {!!formProps.errors.checkBoxValidation ? (
                                                <FormHelperText error>
                                                    {formProps.errors.checkBoxValidation}
                                                </FormHelperText>
                                            ) : null}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => handleCancel()} color="primary">
                                    Cancelar
                                </Button>
                                <Button
                                    onClick={() => {
                                        formProps.validateForm().then((res) => {
                                            if (Object.keys(res).length <= 0) {
                                                saveContent(formProps.values, selectedSchedule);
                                            }
                                        });
                                    }}
                                    color="primary">
                                    Salvar
                                </Button>
                            </DialogActions>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    );
};

function Schedules(props) {
    const { classes, data, setData, intl } = props;
    const { canEdit, errorsList, setErrorsList } = useContext(FormServiceContext);
    const [open, setOpen] = useState(false);
    const [selectedSchedule, setSelectedSchedule] = useState(null);

    const [filteredCollectionData, setFilteredCollectionData] = useState({
        dataBoExcluido: [],
        dataBoNotExcluido: [],
    });

    useEffect(() => {
        const init = () => {
            const temp = _.cloneDeep(data);
            const dataBoExcluido = temp.filter((c) => c.boExcluido);
            const dataBoNotExcluido = temp.filter((c) => !c.boExcluido);
            setFilteredCollectionData({
                dataBoExcluido,
                dataBoNotExcluido,
            });
        };
        init();
    }, [data]);

    const weeklyDays = useMemo(() => {
        if (data.length >= 1) {
            const arrayOfDays = [];

            data.forEach((schedule) => {
                const filteredDays = [
                    schedule.boSegunda && 'Seg',
                    schedule.boTerca && 'Ter',
                    schedule.boQuarta && 'Qua',
                    schedule.boQuinta && 'Qui',
                    schedule.boSexta && 'Sex',
                    schedule.boSabado && 'Sab',
                    schedule.boDomingo && 'Dom',
                ]
                    .filter((day) => day)
                    .join(', ');

                arrayOfDays.push(filteredDays);
            });

            return arrayOfDays;
        }
    }, [data]);

    const changeElement = async (index) => {
        let temp = [...data];
        if (index === undefined) {
            handleClickOpen(temp.length);
        } else {
            if (window.confirm('Deseja excluir este item?')) {
                temp = verifyLicencaNameAndFormat({ filteredCollectionData, index, cdLicencaName: 'cdLicencaHorario' });
            }
        }
        setData(temp);
    };

    const handleClickOpen = (index) => {
        setSelectedSchedule(index);
        setOpen(true);
    };

    const handleCancel = () => {
        setSelectedSchedule(null);
        setOpen(false);
    };

    const onChangeField = (schedule) => {
        let temp = _.cloneDeep(data);
        const { dataBoExcluido, dataBoNotExcluido } = filteredCollectionData;
        const indexLastSchedule = dataBoNotExcluido.length - 1;

        const newStartTime = moment(schedule.hrInicial);
        const formattedNewStartTime = newStartTime.format('HH:mm');
        const addedOneMinuteNewStartTime = newStartTime.add(1, 'minutes');

        const newEndtime = moment(schedule.hrFinal);
        const formattedNewEndtime = newEndtime.format('HH:mm');
        const subtractedOneMinuteNewEndTime = newEndtime.subtract(1, 'minutes');

        if (formattedNewStartTime >= formattedNewEndtime) {
            notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.SCHEDULE_NOT_BIGGER_EQUAL' }), {
                toastId: 'SCHEDULE_NOT_BIGGER_EQUAL',
                type: 'warning',
            });
            return false;
        }

        const scheduleDaysOfTheWeek = [
            schedule.boSegunda,
            schedule.boTerca,
            schedule.boQuarta,
            schedule.boQuinta,
            schedule.boSexta,
            schedule.boSabado,
            schedule.boDomingo,
        ];

        let errors = 0;
        _.forEach(dataBoNotExcluido, (listTime) => {
            const orderedWeeklyDays = [
                listTime.boSegunda,
                listTime.boTerca,
                listTime.boQuarta,
                listTime.boQuinta,
                listTime.boSexta,
                listTime.boSabado,
                listTime.boDomingo,
            ];

            const listStartTime = moment(listTime.hrInicial, 'HH:mm');
            const listEndTime = moment(listTime.hrFinal, 'HH:mm');

            _.forEach(scheduleDaysOfTheWeek, (day, dayIndex) => {
                if (day && orderedWeeklyDays[dayIndex]) {
                    if (formattedNewStartTime === listTime.hrInicial && formattedNewEndtime === listTime.hrFinal) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.ELEMENT_ALREADY_EXISTS' }), {
                            toastId: 'ELEMENT_ALREADY_EXISTS',
                            type: 'warning',
                        });
                        errors++;
                        return false;
                    }
                    // verifica a sobreprosição
                    if (
                        addedOneMinuteNewStartTime.isBetween(listStartTime, listEndTime) ||
                        subtractedOneMinuteNewEndTime.isBetween(listStartTime, listEndTime)
                    ) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.OVERLAPPING_SCHEDULES' }), {
                            toastId: 'OVERLAPPING_SCHEDULES',
                            type: 'warning',
                        });
                        errors++;
                        return false;
                    }

                    if (
                        listStartTime.isBetween(newStartTime, newEndtime) ||
                        listEndTime.isBetween(newStartTime, newEndtime)
                    ) {
                        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.OVERLAPPING_SCHEDULES' }), {
                            toastId: 'OVERLAPPING_SCHEDULES_#2',
                            type: 'warning',
                        });
                        errors++;
                        return false;
                    }
                }
            });
        });

        if (errors > 0) {
            return false;
        }

        const dataSend = {
            hrInicial: moment(schedule.hrInicial).format('HH:mm'),
            hrFinal: moment(schedule.hrFinal).format('HH:mm'),
            boSegunda: schedule.boSegunda,
            boTerca: schedule.boTerca,
            boQuarta: schedule.boQuarta,
            boQuinta: schedule.boQuinta,
            boSexta: schedule.boSexta,
            boSabado: schedule.boSabado,
            boDomingo: schedule.boDomingo,
        };

        if (errorsList && errorsList.schedules) {
            const errorsTemp = { ...errorsList };
            delete errorsTemp.schedules;

            setErrorsList(errorsTemp);
        }

        dataBoNotExcluido[indexLastSchedule + 1] = dataSend;

        temp = [...dataBoNotExcluido, ...dataBoExcluido];

        setData(temp);
        handleCancel();
        return true;
    };

    return (
        <>
            <SchedulesDialog
                {...props}
                selectedSchedule={selectedSchedule}
                open={open}
                handleCancel={handleCancel}
                handleSave={onChangeField}
                classes={classes}
            />

            <Grid item xs={12}>
                <h3 className={classes.titleTable}>Lista de horários</h3>
                <Table className={errorsList?.schedules ? classes.tableError : classes.table}>
                    <TableHead>
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.headTableCell} align="left">
                                Horário inicial
                            </TableCell>
                            <TableCell className={classes.headTableCell} align="left">
                                Horário final
                            </TableCell>
                            <TableCell className={classes.headTableCell} align="left">
                                Dias da semana
                            </TableCell>
                            {canEdit && (
                                <TableCell className={classes.headTableCell} align="center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        onClick={() => changeElement()}
                                        className={classes.addButton}>
                                        <AddIcon /> Adicionar
                                    </Button>
                                </TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredCollectionData.dataBoNotExcluido.map((row, indexRow) => {
                            return (
                                <TableRow key={`irr-row-${indexRow}`} className={classes.tableRow}>
                                    <TableCell align="left">{row.hrInicial}</TableCell>
                                    <TableCell align="left">{row.hrFinal}</TableCell>
                                    <TableCell align="left">{weeklyDays[indexRow]}</TableCell>
                                    {canEdit && (
                                        <TableCell align="right">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => changeElement(indexRow)}
                                                className={classes.btnSigleAction}
                                                size="small">
                                                <DeleteIcon fontSize="inherit" />
                                            </Button>
                                        </TableCell>
                                    )}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Grid>
        </>
    );
}

export default injectIntl(Schedules);
